import Vue from 'vue'
import Router from 'vue-router'
import AppVision from './components/Vision.vue'
import AppGuide from './components/Guide.vue'
import AppGuideEn from './components/Guide-en.vue'

Vue.use(Router)

// The 'vision' component holds both the image and analysis steps, whereas 'guide' and 'about' take you to those specific pages.

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'vision',
      component: AppVision
    },
    {
      path: '/guide',
      name: 'guide',
      component: AppGuide
    },
    {
      path: '/guide-en',
      name: 'guide-en',
      component: AppGuideEn
    }
  ]
})
